import { useHistory } from "react-router-dom";

export function Merch() {
    let history = useHistory();
    window.open("https://tokopedia.com/stei-itb-20", "/");
    history.go(-1);
    return null;
  };